import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import { useAnalyticsStore } from "./AnalyticsStore/analyticsStore";
import { fetchSitesByParentGroup } from "./AnalyticsStore/analyticsStore";
import { NavigateFunction } from "react-router-dom";
import { updateSearchParamValues } from "../../utils/updateSearchParamValues";

export const ParentGroupsDropDown = ({
  navigate,
  navBarCollapsed,
  searchParams,
  setSearchParams,
}: {
  navigate: NavigateFunction;
  navBarCollapsed: boolean;
  searchParams: URLSearchParams;
  setSearchParams: (searchParams: URLSearchParams) => void;
}) => {
  const {
    userFilters,
    setUserFilters,
    setSiteDropDownValue,
    setCameraDropDownValue,
    setSiteOptions,
  } = useAnalyticsStore();

  const parentAccounts = JSON.parse(localStorage?.parentAccounts || "[]");

  const parentIds = new Map();
  const parentNames = new Map();
  parentAccounts.forEach((object: any) => {
    parentIds.set(object.name, object.id);
  });
  parentAccounts.forEach((object: any) => {
    parentNames.set(object.id, object.name);
  });

  return (
    <div key="parent_groups_dropdown">
      <Autocomplete
        disablePortal
        options={
          parentAccounts[0]
            ? parentAccounts.map((object: any, index: number) => ({
                id: object.id,
                name: object.name,
                index: index,
              }))
            : []
        }
        getOptionLabel={(option) => option.name || ""}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        value={
          userFilters.parent_group
            ? {
                id: Number(userFilters.parent_group),
                name: parentNames.get(Number(userFilters.parent_group)),
                index: parentAccounts.findIndex(
                  (obj: any) => obj.id === Number(userFilters.parent_group)
                ),
              }
            : null
        }
        onChange={(event, value: any) => {
          setSiteDropDownValue([]);
          localStorage.setItem(
            "siteDropDownValueAnalytics",
            JSON.stringify([])
          );
          setCameraDropDownValue([]);
          localStorage.setItem(
            "cameraDropDownValueAnalytics",
            JSON.stringify([])
          );

          if (localStorage.filtersSavedClicked === "true") {
            localStorage.setItem(
              "savedAnalyticsFilters",
              JSON.stringify({
                parent_group: value?.id || "",
                site: [],
                camera: [],
                start_date: userFilters.start_date,
                end_date: userFilters.end_date,
              })
            );
          }

          if (value !== null) {
            localStorage.setItem("analyticsParentGroupId", value.id);

            fetchSitesByParentGroup(value.id, navigate);

            setUserFilters((previousState) => {
              return {
                ...previousState,
                parent_group: value.id,
                site: [],
                camera: [],
              };
            });
            updateSearchParamValues(
              {
                ...userFilters,
                parent_group: value.id,
                site: [],
                camera: [],
              },
              searchParams,
              setSearchParams,
              ""
            );
          } else {
            setSiteDropDownValue([]);
            localStorage.setItem(
              "siteDropDownValueAnalytics",
              JSON.stringify([])
            );
            setSiteOptions([]);
            localStorage.setItem("analyticsParentGroupId", "");

            setUserFilters((previousState) => {
              return {
                ...previousState,
                parent_group: "",
                site: [],
                camera: [],
              };
            });
            updateSearchParamValues(
              {
                ...userFilters,
                parent_group: "",
                site: [],
                camera: [],
              },
              searchParams,
              setSearchParams,
              ""
            );
          }
        }}
        sx={navBarCollapsed ? { width: 275 } : { width: 200 }}
        renderInput={(params) => (
          <TextField {...params} label="Parent Group" autoComplete="off" />
        )}
        renderOption={(props, option) => (
          <li {...props} key={option.id}>
            {option.name}
          </li>
        )}
      />
    </div>
  );
};
